import React from "react";
import ContactDetails from "../ContactDetails/ContactDetails";

const ContactLayout = () => {

  return <ContactDetails />;
};

export default ContactLayout;
